import { alertsNotificationsGetter } from './AlertsNotifications';

export const initialNotifications = {
  CUSTOM_LEFT: [],
  CUSTOM_RIGHT: [],
};

/*
 * Getter must return new updated notification object in the following format:
 * {
 *   CUSTOM_LEFT: [...],
 *   CUSTOM_RIGHT: [...],
 * }
 * CUSTOM_LEFT and CUSTOM_RIGHT should be concatted with the already existing notifications!
 **/
function _combineNotifications (...getters) {
  return (notifications) => {
    return getters.reduce(
      (reduced, getter) => {
        try {
          return getter(reduced);
        } catch(e) {
          Logger.error(e);
          return reduced;
        }
      },
      notifications
    )
  }
}

export function getLoginCustomNotifications () {
  return _combineNotifications(
    alertsNotificationsGetter(), // Get custom login notifications when trying to access New Alerts
  )(initialNotifications);
}
